import { z } from 'zod/v4'
import { UIControlSchema } from '@features/ui/types'

export const ActionSchema = z.object({
  id: z.string(),
  label: z.string(),
  icon: z.string().nullable(),
  modelId: z.string(),
  identifierKey: z.string().nullable().optional(),
  inputsVersionId: z.string().nullable().optional(),
  inputs: z.record(
    z.string(),
    z.object({
      label: z.string(),
      value: z.string(),
      control: UIControlSchema,
      required: z.boolean(),
      description: z.string(),
    }),
  ),
  batch: z.boolean(),
  trigger: z.object({
    id: z.string(),
    appInstallation: z
      .object({
        id: z.string(),
        app: z.object({
          id: z.string(),
          name: z.string(),
          publisherLogoUrl: z.string(),
        }),
      })
      .optional()
      .nullable(),
  }),
})
